// src/features/marketResearch/components/sections/EconomicIndicators.tsx
import React from 'react';
import { Grid, Typography, Card } from '@mui/material';
import { SectionContainer, SectionTitle, SectionBody } from '../Section'; // Your new Section.tsx

interface EconData {
  employmentTrends?: string;
  tourismOutlook?: string;
  businessActivity?: string;
}

interface Props {
  data?: EconData;
}

export const EconomicIndicators: React.FC<Props> = ({ data }) => {
  const { employmentTrends = 'N/A', tourismOutlook = 'N/A', businessActivity = 'N/A' } = data || {};

  const indicators = [
    { title: 'Employment Trends', text: employmentTrends },
    { title: 'Tourism Outlook', text: tourismOutlook },
    { title: 'Business Activity', text: businessActivity },
  ];

  return (
    <SectionContainer id="economic-indicators">
      {' '}
      {/* Uses your new SectionContainer styling */}
      <SectionTitle>Economic Indicators</SectionTitle> {/* Uses your new SectionTitle styling */}
      <SectionBody>
        <Grid container spacing={3}>
          {indicators.map(({ title, text }, idx) => (
            <Grid item xs={12} md={4} key={idx}>
              {/* These are individual items within SectionBody. If they need a different background: */}
              {/* Option 1: Text directly on SectionContainer's background */}
              {/* <Box>
                <Typography variant="subtitle1" sx={{ mb: 1.5, color: '#90CAF9' }}>{title}</Typography>
                <Typography variant="body1" sx={{ color: lightTextColor }}>{text}</Typography>
              </Box> */}

              {/* Option 2: Each indicator as a Card (dark text on white card, styled by theme) */}
              <Card sx={{ p: 2.5, height: '100%' }}>
                <Typography variant="h6" sx={{ mb: 1.5, color: 'text.secondary', fontSize: '1rem' }}>
                  {' '}
                  {/* Or subtitle1. Dark text on white Card */}
                  {title}
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.primary' }}>
                  {' '}
                  {/* Dark text on white Card */}
                  {text}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </SectionBody>
    </SectionContainer>
  );
};
